import React, { useCallback, useContext } from 'react'
import { Grid, Header, Icon } from 'semantic-ui-react'
import { useMessageResources, useTextResources } from '../../language'
import {icons} from './icons'
import './style.css'
import { isMobileOnly } from 'mobile-device-detect'
import ApplicationContext from '../../context'
import { onWarning } from '../../components/shared/messages'
import MainMenu from '../../components/MainMenu'
import PropTypes from 'prop-types'
import { endpoint } from '../../api/http'
import { HomePagePopups } from './popups'
import { useState } from 'react'

export const HomePage = ({HotelID, noMenu})=>{
    const text = useTextResources()
    const message = useMessageResources()
    const {state} = useContext(ApplicationContext)
    const [activePopup, setActivePopup] = useState(0)
    const showSysMenu = window.user?.UserRoles[0].Role.SystemRoleTypeID == 1;
    
    const handleClick = useCallback((e, item)=>{
        if (item.externalSystemID > 1000) {
            setActivePopup(item.externalSystemID)
            e.preventDefault()
            return false
        } else if (state.user && state.user.UserExternalSystemsMappings.map(x=>x.ExternalSystemID).includes(item.externalSystemID)){
            if (item.connector) {
                e.preventDefault()
                item.connector()
                return false
            } else {
                return true
            }
        } else {
            e.preventDefault()
            onWarning(message("ThereAreNoPermissionsForThisScreen"))
            return false
        }
    }, [state.user])

    return <>
    {!noMenu && <div id="menu"><MainMenu HotelId={HotelID} /></div>}
    <Grid  columns={isMobileOnly?2:"equal"} stackable={isMobileOnly} style={{flex: 1}} textAlign='center' className="home-page-grid">
        {            
            icons.map((group, idx)=>{
                return <Grid.Column key={idx}>
                    {
                        group.items.filter(item=>(isMobileOnly && item.mobile || !isMobileOnly) && (!item.hide || showSysMenu)).map((item)=>{
                            return <Header key={item.url} as='a' icon href={`${endpoint}${item.url}`} onClick={item.externalSystemID ? e=>handleClick(e, item) : null} >
                                    <Icon className={item.icon} style={{color: group.color }}/>
                                    <div className="title">{text(item.title)}</div>
                                </Header>
                        })
                    }
                </Grid.Column>
            })
        }
    </Grid>
    {activePopup!==0 && <HomePagePopups active={activePopup} HotelId={HotelID} onClose={()=>setActivePopup(0)}/>}
    </>
}

HomePage.propTypes = {
    HotelID: PropTypes.number,
    noMenu: PropTypes.bool
}